export function isAvailableSupplierName(supplierName: string, availableSuppliers: string[] = []): boolean {
  return (
    !supplierName ||
    availableSuppliers.map((supplier) => supplier.trim().toUpperCase()).includes(supplierName.trim().toUpperCase())
  )
}
